export default [
  {
    path: '/active-users',
    name: 'active-users',
    component: () => import('@/views/pages/partner/active-users/List.vue'),
    meta: {
      name: 'active-users',
      resource: 'Partner - Active Users',
      action: 'manage',
    },
  },
]
